<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  optionslist: {
    type: Array,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  tabindex: {
    type: Number,
  },
  v: {
    type: Object,
    required: true,
  },
})

const emits = defineEmits(['update:modelValue', 'blur', 'changed'])

const theme = inject('widgetTheme')

function getErrorMsg(err) {
  if (err) {
    if (err.$params.msg)
      return err.$params.msg
    if (err.$message)
      return err.$message
  }
}

const errors = computed(() => props.v.$errors.slice(0, 1))

watch(
  () => props.modelValue,
  (newVal, oldVal) => {
    if (newVal !== oldVal)
      emits('changed')
  },
)
</script>

<template>
  <div class="cd-form__input-container" :class="[theme !== 'default' ? `cd-${theme}-label` : '']">
    <template v-if="theme === 'material'">
      <div class="cd-form_select-container" :class="{ 'cd-form_select-container-selected': modelValue }">
        <select
          :id="name"
          :value="modelValue"
          :tabindex="tabindex"
          :name="name"
          v-bind="$attrs"
          @input="$emit('update:modelValue', $event.target.value)"
          @blur="$emit('blur')"
        >
          <option />
          <option v-for="(option, index) in props.optionslist" :key="index" :value="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
      <div class="cd-form__label-container">
        <label :for="name">{{ label }}</label>
      </div>
    </template>
    <template v-else>
      <div class="cd-form__label-container">
        <label :for="name">{{ label }}</label>
      </div>
      <select
        :id="name"
        :value="modelValue"
        :tabindex="tabindex"
        :name="name"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="$emit('blur')"
      >
        <option />
        <option v-for="(option, index) in props.optionslist" :key="index" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </template>

    <FormError :message="getErrorMsg(errors[0])" />
  </div>
</template>
